import { ReactNode } from "react";

import styles from "@components/typography/Typography.module.css";

type Props = {
  children: ReactNode;
};

const InputSubLabel = ({ children }: Props) => <span className={styles.inputSubLabel}>{children}</span>;

export default InputSubLabel;
